import { Fragment } from 'react';
import { Text } from '~/components/ui/Text';
import {
	StyledBottomText,
	StyledCenterBlock,
	StyledContainer,
	StyledResultIcon,
	StyledResultIconContainer,
} from './ResultOverlay.styled';

const ResultOverlay = ({ type }: { type: 'win' | 'lose' }) => {
	return (
		<StyledContainer $type={type}>
			<StyledCenterBlock>
				<StyledResultIconContainer>
					<StyledResultIcon />
				</StyledResultIconContainer>
				<Text>
					{type === 'win' ? (
						<Fragment>
							СВЯЗЬ
							<br />
							ВОССТАНОВЛЕНА
						</Fragment>
					) : (
						<Fragment>
							СВЯЗЬ
							<br />
							РАЗОРВАНА
						</Fragment>
					)}
				</Text>
			</StyledCenterBlock>
			<StyledBottomText>CCDPLANET CITY ENERGY SYSTEM 0.0.1</StyledBottomText>
		</StyledContainer>
	);
};

export { ResultOverlay };
